import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2024c14a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "THE FIELDS MARKED WITH (*) ARE REQUIRED.", -1))
const _hoisted_3 = { class: "input-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "TITLE*", -1))
const _hoisted_5 = { class: "input-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "DESCRIPTION*", -1))
const _hoisted_7 = { class: "image-container" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "input-container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "DATE FROM*", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "DATE TO*", -1))
const _hoisted_13 = { class: "input-container" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "CURATED BY*", -1))
const _hoisted_15 = { class: "input-container" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "ARTWORKS*", -1))
const _hoisted_17 = { class: "buttons-container" }
const _hoisted_18 = {
  key: 1,
  color: "primary",
  type: "submit"
}
const _hoisted_19 = {
  key: 2,
  color: "primary",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_MainLayout = _resolveComponent("MainLayout")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("form", {
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateExhibition && _ctx.updateExhibition(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
              "single-line": ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_QuillEditor, {
              theme: "snow",
              toolbar: "full",
              contentType: "html",
              content: _ctx.description,
              "onUpdate:content": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.description) = $event)),
              placeholder: "Add description here...",
              style: {"height":"300px","width":"100%"}
            }, null, 8, ["content"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.imageUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.imageUrl
                }, null, 8, _hoisted_8))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: require('@/assets/imgs/avatar.png')
                }, null, 8, _hoisted_9)),
            _createElementVNode("label", null, [
              _createTextVNode(" UPLOAD IMAGE "),
              _createElementVNode("input", {
                id: "image-upload",
                type: "file",
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
                style: {"display":"none"}
              }, null, 32)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _hoisted_11,
              _createVNode(_component_v_text_field, {
                type: "date",
                modelValue: _ctx.dateFrom,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dateFrom) = $event)),
                "single-line": ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", null, [
              _hoisted_12,
              _createVNode(_component_v_text_field, {
                type: "date",
                modelValue: _ctx.dateTo,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dateTo) = $event)),
                "single-line": ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.curatedBy,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.curatedBy) = $event)),
              "single-line": ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_v_select, {
              items: _ctx.artworksTitleAndFullName,
              modelValue: _ctx.artworksSelected,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.artworksSelected) = $event)),
              "item-text": "title",
              "item-value": "id",
              chips: "",
              multiple: "",
              required: ""
            }, null, 8, ["items", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.back()))
            }, "BACK"),
            (_ctx.id)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  color: "error",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.deleteExhibition(_ctx.id)))
                }, " DELETE "))
              : _createCommentVNode("", true),
            (_ctx.id)
              ? (_openBlock(), _createElementBlock("button", _hoisted_18, "Update"))
              : _createCommentVNode("", true),
            (!_ctx.id)
              ? (_openBlock(), _createElementBlock("button", _hoisted_19, "Publish"))
              : _createCommentVNode("", true)
          ])
        ], 32)
      ])
    ]),
    _: 1
  }))
}